import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQueries } from "@tanstack/react-query";
import postSiteBatteryAnalysis from "../http/postSiteBatteryAnalysis";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSiteBatteryAnalysis = ({
  onlySyntheticBatteries,
  payload,
  esysIdx,
}: {
  onlySyntheticBatteries: boolean;
  payload: any;
  esysIdx: string | number;
}) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const batteryQueries = useQueries({
    queries: Array.from({ length: 5 }, (_, i) => i + 1).map((page) => {
      return {
        // Including payload in the key ensures that we cache the results with a payload
        // under a different key than the results without a payload.
        queryKey: ["site", "battery", esysIdx, page, payload !== undefined],
        queryFn: async () =>
          postSiteBatteryAnalysis(
            await getAuthTokenBlocking(getToken, relogin),
            esysIdx,
            page,
            onlySyntheticBatteries,
            payload
          ),
        staleTime: Infinity,
        enabled: false,
      };
    }),
  });

  return {
    batteryQueries,
  };
};

export default useSiteBatteryAnalysis;
